import React from 'react';
import PropTypes from 'prop-types';

import styles from './InfoItem.scss';

export default function InfoItem(props = {}) {
    const { copyPrimary, copySecondary, Icon } = props;

    return (
        <div className={styles.infoItem}>
            <div className={styles.infoIcon}>
                <Icon />
            </div>
            <div className={styles.infoTextPrimary}>{copyPrimary}</div>
            <div className={styles.infoTextSecondary}>{copySecondary}</div>
        </div>
    );
}

InfoItem.propTypes = {
    copyPrimary: PropTypes.node.isRequired,
    copySecondary: PropTypes.node,
    Icon: PropTypes.func.isRequired,
};
